module.exports = __webpack_public_path__ + "images/index/img01.66e202b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/proimg/wenhua/new/img01.jpg
// module id = 3Sn+
// module chunks = 21